import {FormikProps} from 'formik';
import {notify} from '@gemcook/notification';

import constants from '@constants';
import utils from '@utils';

export const changeDateDuration = async (
  formProps: FormikProps<any>,
  field: any,
  value: any,
  actions: NotificationsAction,
  me: MeStore
) => {
  formProps.setFieldValue(`${field.name}`, value);
  formProps.setSubmitting(true);
  const currentDate = utils.date.getNow('YYYY年MM月DD日 HH時mm分ss秒');
  try {
    const notification = await actions.notifications.getSummarizedNotification({
      teamId: me.teamId,
      currentDate: utils.date.format(
        formProps.values.currentDate,
        'YYYY/MM/DD',
        true
      ),
      traceDuration: value,
    });
    actions.notifications.updateSearchTime(currentDate);

    let isAnswered: any;
    // 未回答にチェックが入っている場合、isAnsweredをfalseにする
    if (formProps.values.unAnswered) {
      isAnswered = !formProps.values.unAnswered;
    }
    if (formProps.values.answered) {
      isAnswered = formProps.values.answered;
    }
    // 回答済み、未回答が両方チェックの時、パラメーターを渡さないようにする
    if (formProps.values.unAnswered && formProps.values.answered) {
      isAnswered = undefined;
    }
    // 検索対象のユーザー名の配列を作成
    const names = formProps.values.userNames.map((user: any) => user.text);
    // 検索対象の役職の配列を作成
    const positions = formProps.values.positions.map(
      (position: any) => position.text
    );
    // 検索対象の組織の配列を作成
    const organizations = formProps.values.organizations.map(
      (organization: any) => organization.text
    );

    if (notification.value.detail.data.notificationIds) {
      await actions.notifications.updateCurrentNotificationDetail({
        page: 1,
        sort: '-replyDatetime',
        notificationId: notification.value.detail.data.notificationIds,
        isSafe: formProps.values.isSafe,
        isMinorInjury: formProps.values.isMinorInjury,
        isSeriousInjury: formProps.values.isSeriousInjury,
        isAnswered,
        name: names,
        position: positions,
        organization: organizations,
      });
      formProps.setSubmitting(false);
      // 検索条件をStoreに保存
      actions.notifications.updateDetailSearchWords({
        names,
        positions,
        organizations,
        isAnswered,
        isSafe: formProps.values.isSafe,
        isMinorInjury: formProps.values.isMinorInjury,
        isSeriousInjury: formProps.values.isSeriousInjury,
      });
    } else {
      actions.notifications.clearDetailSort();
      actions.notifications.clearDetailSearch();
    }
  } catch (error) {
    notify(constants.ERRORS.UNKNWON, 'error');
  } finally {
    formProps.setSubmitting(false);
  }
};
